import Loading from 'components/Loading';
import config from 'config';
import storageItems from 'constants/storageItems';
import { Map } from 'immutable';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Loadable from 'react-loadable';
import { Fragment } from 'redux-little-router';
import ConfigWrapper from 'containers/ConfigWrapper';
import { routeMap } from 'router';
import Storage from 'services/Storage';
import DownloadTapsPdfContainer from '../../containers/DownloadTapsPdfContainer';
import HeaderContainer from '../../containers/HeaderContainer';
import HomeContainer from '../../containers/HomeContainer';
import RedirectToLKIPContainer from '../../containers/RedirectToLKIPContainer';
import WaitingPageContainer from '../../containers/WaitingPageContainer';
import CodeWord from '../CodeWord/index';
import DownloadPdf from '../DownloadPdf/index';
import DownloadLkCsvFile from '../DownloadCsv_LkApi/index';
import PreviewAndDownloadPdf from '../PreviewAndDownloadPdf/index';
import SetPassword from '../SetPasswordForm/index';
import Modal from '../../../../components/Modal';
import PacageDescriptionErrorModal from '../../components/PacageDescriptionErrorModal';
import RedirectToExternalServices from '../RedirectToExternalServices/RedirectToExternalServices';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import ErrorPageContainer from 'modules/App/components/ErrorPage/ErrorPageContainer';
import { LoadingWithError } from '../../../../components/Loading/LoadingWithError';
import { default as PercentDepositsSituation } from 'modules/Taps/components/PercentDeposits';
import ArmyMeasures from 'modules/Taps/components/ArmyMeasures';
import MobilizationReport from 'modules/Taps/components/MobilizationReport';
import Questions from '../Questions';
import HelpNavButtonContainer from 'modules/App/containers/HelpNavButtonContainer';
import { pathsCompliance, remotePaths } from 'router/routes';

// eslint-disable-next-line react/prop-types
export const redirectFn = () => {
  const remotePath = pathsCompliance[window.location.pathname];
  if (pathsCompliance[window.location.pathname]) {
    config.goToNewLK(remotePath);
  }
};

const HelpPage = Loadable({
  loader: () =>
    import(/* webpackChunkName:"chunk-HelpPage" */ '../../../Help/components/HelpContainer'),
  loading: Loading,
});
const HelpBiggestPage = Loadable({
  loader: () =>
    import(/* webpackChunkName:"chunk-HelpPage" */ '../../../Help/components/HelpBiggest'),
  loading: Loading,
});
const SituationsContainer = Loadable({
  loader: () =>
    import(
      /* webpackChunkName:"chunk-SituationsContainer" */ '../../../Taps/containers/SituationsContainer'
    ),
  loading: LoadingWithError,
});

const PropertyObjectsContainer = Loadable({
  loader: () =>
    import(
      /* webpackChunkName:"chunk-PropertyObjectsContainer" */ '../../containers/PropertyObjectsContainer'
    ),
  loading: LoadingWithError,
});

const MyTaxesContainer = Loadable({
  loader: () =>
    import(
      /* webpackChunkName:"chunk-PropertyObjectsContainer" */ '../../containers/MyTaxesContainer'
    ),
  loading: LoadingWithError,
});
const SiteMapContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName:"chunk-SiteMapContainer" */ '../../containers/SiteMapContainer'),
  loading: LoadingWithError,
});

const ProfileWrapperContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName:"chunk-Profile" */ '../../../Profile/containers/WrapperContainer'),
  loading: LoadingWithError,
});
const MessagesWrapperContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName:"chunk-Messages" */ '../../../Messages/containers/WrapperContainer'),
  loading: LoadingWithError,
});
const ContactsWrapperContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName:"chunk-Contacts" */ '../../../Contacts/containers/WrapperContainer'),
  loading: LoadingWithError,
});
const UserIncomesWrapperContainer = Loadable({
  loader: () => import(/* webpackChunkName:"chunk-UserIncomes" */ '../../../UserIncomes'),
  loading: LoadingWithError,
});

const DeclarationsWrapperContainer = Loadable({
  loader: () => import(/* webpackChunkName:"chunk-Declarations" */ '../../../Declarations'),
  loading: LoadingWithError,
});

const IncomesAndTaxDeductionsWrapperContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName:"chunk-UserIncomes" */ '../../../IncomesAndTaxDeductions'),
  loading: LoadingWithError,
});

const TaxDeductionsWrapperContainer = Loadable({
  loader: () => import(/* webpackChunkName:"chunk-UserIncomes" */ '../../../TaxDeductions'),
  loading: LoadingWithError,
});

export default class ContentWrapper extends Component {
  static propTypes = {
    router: PropTypes.object.isRequired,
    user: PropTypes.instanceOf(Map).isRequired,
    incomingData: PropTypes.instanceOf(Map).isRequired,
    contactInfo: PropTypes.instanceOf(Map).isRequired,
    goToHomePage: PropTypes.func.isRequired,
    getUserInfo: PropTypes.func.isRequired,
    getContactInfo: PropTypes.func.isRequired,
    loadModalConfig: PropTypes.func.isRequired,
    loadSituationsConfig: PropTypes.func.isRequired,
  };

  state = {
    showCodeWordForm: false,
    showPackageDescriptionModal: false,
    footerHiden: false,
  };

  componentDidMount() {
    const { user, contactInfo, getUserInfo, getContactInfo, loadModalConfig } = this.props;

    loadModalConfig();
    if (user.get('data').isEmpty() && !user.get('loading')) {
      getUserInfo();
    }
    if (!contactInfo.get('data')) {
      getContactInfo();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { contactInfo, user } = nextProps;
    const { contactInfo: currentContactInfo } = this.props;
    const currentData = currentContactInfo.get('data');
    const data = contactInfo.get('data');
    const codeFormIsDisabled = Storage.getItem(storageItems.CODE_WORD_IS_DISABLED);
    const needShow =
      !currentData &&
      data &&
      !data.hasCodeWord &&
      !codeFormIsDisabled &&
      !config.isInspectorArm &&
      data.isEmailConfirm;
    const { data: userData } = user.toJS();
    const showPackageDescriptionModal =
      userData &&
      userData.showPackageDescriptionBanner &&
      !Storage.getItem(storageItems.PACKAGE_DESCRIPTION_DISABLED);
    const showConvertationModal =
      !isEmpty(userData) &&
      userData.isConvertation &&
      !Storage.getItem(storageItems.CONVERTATION_IS_DISABLED);
    if (showPackageDescriptionModal) {
      this.setState({ showPackageDescriptionModal: true });
    }
    if (needShow) {
      this.setState({ showCodeWordForm: true });
    }
    if (showConvertationModal) {
      this.setState({ showConvertationModal: true });
    }
  }

  closeConvertation = () => {
    this.setState({ showConvertationModal: false });
    Storage.setItem(storageItems.CONVERTATION_IS_DISABLED, true);
  };
  handleHidePackageDescriptionModal = () => {
    this.setState({ showPackageDescriptionModal: false }, () => {
      Storage.setItem(storageItems.PACKAGE_DESCRIPTION_DISABLED, true);
    });
  };

  handleHideCodeWordModal = () => {
    this.setState({ showCodeWordForm: false }, () => {
      Storage.setItem(storageItems.CODE_WORD_IS_DISABLED, true);
    });
  };

  setFooterHiden() {
    this.setState({ footerHiden: true });
  }

  isNotOpenPdf = (loc) => {
    return loc.route !== routeMap.openPdf;
  };

  isHomepage() {
    const { router } = this.props;
    return router.pathname === routeMap.home;
  }

  isRiderectToLKIP() {
    const { router } = this.props;
    return router.pathname === routeMap.lkIp;
  }

  isRiderectToExternalServices() {
    const { router } = this.props;
    return router.pathname === routeMap.externalServices;
  }

  renderLoading() {
    return (
      <div className="main-page">
        <div className="main-page_bg" />
        <HeaderContainer isHomepage={true} />

        <div className="main-page_center">
          <div className="main-page_cell">
            <div className="content">
              <Loading isLight={true} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderHomepage(isHomepage) {
    config.goToNewLK();
    const { user } = this.props;
    const { data } = user.toJS();
    const CodeWordWrapper = ConfigWrapper(
      <CodeWord
        key={'MW_CONTROL_WORD'}
        onHideModal={this.handleHideCodeWordModal}
        showModal={this.state.showCodeWordForm}
      />,
    );
    const SetPasswordWrapper = ConfigWrapper(<SetPassword key={'MW_PERS_PWD'} />);
    return (
      <div className="main-page">
        <div className="main-page_bg" />
        <HeaderContainer isHomepage={isHomepage} />

        {/* <MenuContainer isMobile={true} /> */}

        <Fragment forRoute={routeMap.home}>
          <HomeContainer isHomepage={isHomepage} />
        </Fragment>
        <PacageDescriptionErrorModal
          key={'packageDescriptionModal'}
          ref={'packageDescription'}
          showModal={this.state.showPackageDescriptionModal}
          onHideModal={this.handleHidePackageDescriptionModal}
        />

        {data.isPrimaryPassword && !config.isInspectorArm ? (
          <SetPasswordWrapper />
        ) : (
          <CodeWordWrapper />
        )}
        {this.renderConvertationModal()}
      </div>
    );
  }

  renderConvertationModal() {
    const { user } = this.props;
    return user.getIn(['data', 'isConvertation']) ? (
      <Modal
        horizontalCentering={true}
        popupWrapperStyle={{ borderRadius: '10px' }}
        onClose={this.closeConvertation}
        showModal={this.state.showConvertationModal}
      >
        <p>Уважаемый пользователь!</p>
        В связи с проведением технологических работ данные в Вашем личном кабинете могут обновляться
        с задержкой. Кроме этого, возможно ограничение на отправку некоторых заявлений из Личного
        кабинета.
        <br />
        Федеральная налоговая служба приносит извинения за доставленные неудобства.
      </Modal>
    ) : null;
  }

  renderWaitingPage() {
    return (
      <div className="main-page">
        <div className="main-page_bg" />
        <HeaderContainer isHomepage={true} showLogoutLink={true} showAccessibilityLink={true} />

        <WaitingPageContainer />
      </div>
    );
  }

  renderPage(isHomepage) {
    const { router, user, goToHomePage } = this.props;
    const {
      pdf,
      url,
      bankId,
      bankJson,
      filename,
      skipPrepare,
      serverFileName,
      attachmentId,
      notificationId,
      attachmentType,
      documentNumber,
    } = router.query;
    let parsedJson;
    const { data } = user.toJS();

    if ((router.route === routeMap.openPdf || router.route === routeMap.openTapsPdf) && !pdf) {
      goToHomePage();
    }

    if (bankJson) {
      try {
        parsedJson = JSON.parse(atob(bankJson));
      } catch (e) {
        goToHomePage();
      }
    }

    if (router.route && router.route === routeMap.redirectUrl && (!bankId || !parsedJson)) {
      goToHomePage();
    }

    let PasswordModal = null;
    if (data.isPrimaryPassword && !config.isInspectorArm) {
      PasswordModal = ConfigWrapper(<SetPassword key={'MW_PERS_PWD'} />);
    }

    return (
      <React.Fragment>
        <div className="wrapper">
          <HeaderContainer isHomepage={isHomepage} />

          <div className="content">
            <div style={{ paddingTop: '12px' }}>
              <a href={remotePaths.situations}>← Вернуться в каталог обращений</a>
            </div>
            <ErrorBoundary pathname={router.pathname}>
              {this.renderConvertationModal()}
              {PasswordModal && <PasswordModal />}
              <Fragment forRoute={routeMap.home}>
                <HomeContainer isHomepage={isHomepage} />
              </Fragment>

              <Fragment forRoute={routeMap.taxes}>
                <MyTaxesContainer />
              </Fragment>

              <Fragment forRoute={routeMap.propertyObjects}>
                <PropertyObjectsContainer />
              </Fragment>

              <Fragment forRoute={routeMap.surveySupportMeasures}>
                <Questions />
              </Fragment>

              <Fragment forRoute={routeMap.requestArmyMeasures}>
                <ArmyMeasures />
              </Fragment>

              <Fragment forRoute={routeMap.mobilizationReport}>
                <MobilizationReport />
              </Fragment>

              <Fragment forRoute={routeMap.helpBiggest}>
                <HelpBiggestPage />
              </Fragment>

              <Fragment forRoute={routeMap.help}>
                <HelpPage />
              </Fragment>

              <Fragment forRoute={routeMap.profile}>
                <ProfileWrapperContainer />
              </Fragment>

              <Fragment forRoute={routeMap.contacts}>
                <ContactsWrapperContainer />
              </Fragment>

              <Fragment forRoute={routeMap.situations}>
                <SituationsContainer />
              </Fragment>

              <Fragment forRoute={routeMap.openPdf}>
                <DownloadPdf pdf={pdf} filename={filename} />
              </Fragment>

              <Fragment forRoute={routeMap.openLkApi}>
                <DownloadLkCsvFile serverFileName={serverFileName} filename={filename} />
              </Fragment>

              <Fragment forRoute={routeMap.previewPdf} withConditions={this.isNotOpenPdf}>
                <PreviewAndDownloadPdf
                  url={url}
                  pdf={pdf}
                  filename={filename}
                  documentNumber={documentNumber}
                />
              </Fragment>

              <Fragment forRoute={routeMap.openTapsPdf}>
                <DownloadTapsPdfContainer
                  attachmentId={attachmentId}
                  attachmentType={attachmentType}
                  notificationId={notificationId}
                  pdf={pdf}
                  skipPrepare={skipPrepare === 'true'}
                  filename={filename}
                />
              </Fragment>

              <Fragment forRoute={routeMap.messages}>
                <MessagesWrapperContainer />
              </Fragment>

              <Fragment forRoute={routeMap.siteMap}>
                <SiteMapContainer />
              </Fragment>

              <Fragment forRoute={routeMap.declarations}>
                <DeclarationsWrapperContainer />
              </Fragment>

              <Fragment forRoute={routeMap.taxDeductions}>
                <TaxDeductionsWrapperContainer />
              </Fragment>

              <Fragment forRoute={routeMap.userIncomes}>
                <UserIncomesWrapperContainer />
              </Fragment>

              <Fragment forRoute={routeMap.incomesAndTaxDeductions}>
                <IncomesAndTaxDeductionsWrapperContainer />
              </Fragment>

              <Fragment forRoute={routeMap.error}>
                <ErrorPageContainer />
              </Fragment>

              {!config.isInspectorArm && (
                <>
                  <Fragment forRoute={routeMap.percentDepositsSituation}>
                    <div className="boo">
                      <div className="mt-4">
                        <h1 className="mb-4">
                          Сообщение об уточнении представленной банком информации о сумме
                          полученного дохода
                        </h1>
                        <PercentDepositsSituation />
                      </div>
                    </div>
                  </Fragment>
                </>
              )}
            </ErrorBoundary>
          </div>
        </div>

        {!this.state.footerHiden && (
          <HelpNavButtonContainer
            onClose={() => {
              this.setFooterHiden(true);
            }}
          />
        )}
      </React.Fragment>
    );
  }

  render() {
    redirectFn();
    const isHomepage = this.isHomepage();
    const { user } = this.props;
    const { data, loading } = user.toJS();

    if (isHomepage && isEmpty(data) && loading) {
      return this.renderLoading();
    } else if (!isEmpty(data) && data.hasData === false) {
      return this.renderWaitingPage();
    } else if (isHomepage) {
      return this.renderHomepage(isHomepage);
    } else if (this.isRiderectToLKIP()) {
      return <RedirectToLKIPContainer />;
    } else if (this.isRiderectToExternalServices()) {
      return <RedirectToExternalServices query={this.props.router.search} />;
    } else {
      return this.renderPage(isHomepage);
    }
  }
}
